<template>
    <el-scrollbar class="chapter-wrapper" style="height: 100%" :native="false">
        <div class="chapter-content">
            <div class="line-item lin-item-one" v-for="(chapterItem, chapterIndex) in chapterList">
                <div class="line-name line-name-one text-overflow" v-if="role === 3">章：{{chapterItem.name}}</div>
                <div class="line-name line-name-one text-overflow" v-else-if="role === 4">第{{getNum(chapterIndex + 1)}}章：{{chapterItem.name}}</div>
<!--                <div class="line-name line-name-one text-overflow">第{{chapterNodeCurrent.length > 0 ? getNum(Number(chapterNodeCurrent[0]) + 1) : getNum(Number(chapterRouteIndex) + 1)}}章：{{chapterItem.name}}</div>-->
                <div v-for="(sectionItem, sectionIndex) in chapterItem.children">
                    <div class="line-name line-name-three line-name-three-two"
                         v-if="Number(sectionItem.type) === 3 || Number(sectionItem.type) === 4"
                         @click="playResource(sectionItem, chapterIndex + '|' + sectionIndex)">
                        <i class="iconfont play-icon">&#xe71e;</i>
                        <span class="name-text text-overflow">资源{{getNum(sectionIndex + 1)}}：{{sectionItem.name}}</span>
                        <span class="teaching-status classing" v-if="getCurrIndex(chapterIndex + '|' + sectionIndex)">
                            <!-- 正在教<i class="iconfont">&#xe8c4;</i> -->
                            <img src="../../assets/images/ing.gif" alt="正在教" style="height: 14px;">
                        </span>
                        <span v-else class="teaching-status" :class="getIndexDone(chapterIndex + '|' + sectionIndex) ? 'classed' : ''">
                            <i class="iconfont" v-if="resourceItem.status">&#xec9e;</i>
                        </span>
                    </div>
                    <div class="line" v-else>
                        <div class="line-name line-name-two text-overflow" v-if="role === 3" :class="sectionIndex === Number(chapterNodeCurrent[1]) ? 'current' : ''">节：{{sectionItem.name}}</div>
                        <div class="line-name line-name-two text-overflow" v-else-if="role === 4" :class="sectionIndex === Number(chapterNodeCurrent[1]) ? 'current' : ''">第{{getNum(sectionIndex + 1)}}节：{{sectionItem.name}}</div>
                        <div class="line">
                            <div class="line-name line-name-three" v-for="(resourceItem, resourceIndex) in sectionItem.children"
                                :style="getCurrIndex(chapterIndex + '|' + sectionIndex + '|' + resourceIndex) ? { background: '#1E1E1E', color: '#fff' } : ''"
                                @click="playResource(resourceItem, chapterIndex + '|' + sectionIndex + '|' + resourceIndex)">
                                <i class="iconfont play-icon">&#xe71e;</i>
                                <span class="name-text text-overflow">资源{{resourceIndex + 1}}：{{resourceItem.name}}</span>
                                <span class="teaching-status classing"
                                      v-if="getCurrIndex(chapterIndex + '|' + sectionIndex + '|' + resourceIndex)">
                                    <!-- 正在教<i class="iconfont">&#xe8c4;</i> -->
                                    <img src="../../assets/images/ing.gif" alt="正在教" style="height: 14px;">
                                </span>
                                <span class="teaching-status" v-else
                                      :class="getIndexDone(chapterIndex + '|' + sectionIndex + '|' + resourceIndex) ? 'classed' : ''">
                                    <i class="iconfont" v-if="resourceItem.status">&#xec9e;</i>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </el-scrollbar>
</template>

<script>
import { recordLessons } from "@/utils/apis"

    export default {
        props: {
            chapterList: {
                type: Array,
            },
            chapterNodeCurrent: {
                type: Array
            },
            currentCourseRecordIndex: {
              type: String
            },
            jieIndex:{ type: String}
        },
        data() {
            return {
                // chapterRouteIndex: this.$route.query.chapter || '',
                // nodeRouteIndex: this.$route.query.node || '',
                id: Number(this.$route.query.id) || '',
                // chapterList: [],
                courseTitle: '',
                pdfSrc: '',
                videoSrc: '',
                indexCurrent: '',
                indexDone: [],
                role: Number(localStorage.getItem('role')),
                timer: null,
            }
        },
        mounted() {

            if (this.chapterList.length > 0) {
                let sectionSt = this.chapterList.length>1? this.chapterList[this.role==4?this.$route.query.chapter:0].children[this.$route.query.node?this.$route.query.node:0]:this.chapterList[0].children[this.$route.query.node?this.$route.query.node:0];
                if (Number(sectionSt.type) === 3 || 4 === Number(sectionSt.type)) {
                    this.indexCurrent = '0|0';
                } else {
                    // this.indexCurrent = '0|0|0';
                    // this.playResource(sectionSt.children[0], this.indexCurrent);
                    this.indexCurrent = `0|${this.$route.query.node||0}|0`;
                    this.playResource(sectionSt.children[0], this.indexCurrent);
                    
                }
            }
            // if (this.currentCourseRecordIndex !== '') {
            //     this.indexCurrent = this.currentCourseRecordIndex;
            //     console.log("this.currentCourseRecordIndex",this.currentCourseRecordIndex);
                
            // }
        },
        methods: {
            // getCourseList(id) {
            //     let params = {
            //         id: id,
            //     }
            //     this.$shttp.axiosGetBy(this.$api.courseContent, params, (res) => {
            //         console.log(res)
            //         if (res.code === 200) {
            //             this.chapterList = res.data.course_content;
            //             this.courseTitle = res.data.course_name;
            //             let sectionSt = this.chapterList[0].children[0];
            //             if (sectionSt.file_name && sectionSt.file_preview_path) {
            //                 this.playResource(sectionSt, '0|0');
            //             } else {
            //                 this.pdfSrc = sectionSt.children[0].file_preview_path;
            //                 this.playResource(sectionSt.children[0], '0|0|0');
            //             }
            //         }
            //     }, (err) => {
            //         console.log(err)
            //     })
            // },
            getNum(num) {
                return this.$common.getNumStr(num);
            },
            getCurrIndex(index) {
                return this.indexCurrent === index;
            },
            getIndexDone(index) {
                let str = this.indexDone.join();
                if (str.indexOf(index) === -1) {
                    return false;
                } else {
                    return true;
                }
            },
            playResource(item, index) {
                localStorage.setItem("project_id",item.id)
                localStorage.setItem("project_type",1)
                this.$emit('getResource', item, index);
                this.indexCurrent = index;
                if (this.indexDone.length) {
                    let str = this.indexDone.join();
                    if (str.indexOf(index) === -1) {
                        this.indexDone.push(index);
                    }
                } else {
                    this.indexDone.push(index);
                }
                const ids = index.split('|');
                let res = `${this.chapterList[ids[0]].name} > ${this.chapterList[ids[0]].children[ids[1]].name } > ${this.chapterList[ids[0]].children[ids[1]].children[ids[2]].name }`;
                this.$emit('getCurrentLocation', res);
                let params = {
                    course_id: this.$route.query.id, // 课程id
                    chapter: this.role == 3 ? this.chapterNodeCurrent[0] : ids[0], // 章索引
                    node: this.role == 3 ? this.chapterNodeCurrent[1] : ids[1], // 节索引
                    resource_index: ids[2], // 资源索引
                    resource_id: item.id, // 资源id
                    type: item.type, // 资源类型
                    c_id: this.role == 3 ? this.$route.query.classId : void 0, // 班级id
                    course_record_id: this.role == 3 ? void 0 : this.$route.query.recordId, // 上课记录id
                }

                    if(this.role==3){
                        localStorage.setItem("teacherChapter",params.chapter)
                    localStorage.setItem("teacherNode",params.node)
                    }else{
                        localStorage.setItem("studentChapter",params.chapter)
                        localStorage.setItem("studentNode",params.node)
                    }
                
     
                // console.log({ params, ids });
                if (!item.status) {
                    if (this.timer) clearInterval(this.timer);
                    this.timer = setInterval(()=>{
                        recordLessons(params).then(res => {
                            if (res.code === 200){
                                this.$emit('recordLessons', ids[0]);
                                clearInterval(this.timer);
                            } 
                        })
                    }, 60000);
                }
            },
        },
        watch: {
            chapterList: {
                handler(newVal, oldVal) {
                    let index = this.indexCurrent = `0|${this.jieIndex||0}|0`;
                    let item = newVal[0].children[this.jieIndex||0].children[0]
                    this.playResource(item, index);
                },
                deep: true 
            }
        },
    }
</script>

<style scoped lang="scss">
.chapter-wrapper {
    height: 100%;
    ::v-deep .el-scrollbar__wrap {
        overflow-x: hidden;
    }
    .chapter-content {
        color: #999;
        margin: 20px 0 150px;
        .line-item {
            &.lin-item-one {
                margin-bottom: 10px;
            }
            .line-name {
                padding: 0 24px;
                &.line-name-one {
                    color: #fff;
                    font-size: 16px;
                    margin-bottom: 32px;
                }
                &.line-name-two {
                    padding-left: 34px;
                    color: #fff;
                    font-size: 16px;
                    margin-bottom: 16px;
                    // &.current {
                    //    color: #ff0000;
                    // }
                }
                &.line-name-three {
                    display: flex;
                    cursor: pointer;
                    padding-left: 54px;
                    line-height: 53px;
                    font-size: 16px;
                    color: #999;
                    .name-text {
                        margin-left: 8px;
                    }
                    .name-text {
                        width: 1%;
                        flex: 1;
                    }
                    .teaching-status {
                        width: 30px;
                        display: flex;
                        justify-content: flex-end;
                        align-items: center;
                        .iconfont {
                            margin-left: 10px;
                        }
                        &.classed {
                            color: #3296FA;
                        }
                        &.classing {
                            color: #ff0000;
                        }
                    }
                }
                &.line-name-three-two {
                    padding-left: 40px;
                }
            }
        }
    }
}
</style>